import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

import { TimerService } from '@frontend/sports/common/core/utils/timer';

@Directive({ selector: '[msScrollToActive]' })
export class ScrollToActiveDirective implements AfterViewInit {
    private element = inject(ElementRef);
    private timer = inject(TimerService);

    ngAfterViewInit(): void {
        const child = this.element.nativeElement.querySelector('.active') as HTMLElement;
        if (!child) {
            return;
        }

        this.timer.setAnimationFrame(() => {
            this.element.nativeElement.scrollTop = child.offsetTop - this.element.nativeElement.clientHeight / 2 + child.clientHeight / 2;
        });
    }
}
